import { IValidations } from '../../../../../../../components/Forms/Forms';

export const validations: IValidations = {
  flight: 'required',
  'user.email': ['required', 'email'],
  'user.firstName': 'required',
  'user.lastName': 'required',
  'user.profile.ghinNumber': 'required'
};
